import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';
import { RxUtil } from '@commons/util/utilities/rx';
import { IPromise, IQService } from 'angular';
import { map } from 'rxjs';

import {
  Booking,
  ContactDoc,
  CSR_FACADE_PREFIX,
  CustomerData,
  CustomerFacade,
  CustomerService,
  ElasticSearchService,
  Entity,
  User,
  UserElsQuery,
} from '@contact/upgrade';

/**
 * @deprecated
 */
export interface IRecipient extends Entity {
  contactId: string; // Id of the contact
  uuid: string; // UUID of the contact
  id: string; // eptica iasID of the contact
  lastname: string; // lastname of the contact
  firstname: string; // firstname of the contact
  phone: string; // Phone number of the contact
}

/**
 * @deprecated
 */
export interface ICustomerCardsDeprecatedService {
  /**
   * @deprecated
   */
  linkCustomerCardToResponse(responseId: string, customerId: string, uri?: string): IPromise<any>;
  /**
   * @deprecated
   */
  linkContactEntryToContact(interactionId: string, customerId: string): IPromise<any>;
  /**
   * @deprecated
   */
  displayPresomption(uri?: string): void;
  /**
   * @deprecated
   */
  displayNewCustomerCard(): void;
  /**
   * @deprecated
   */
  displayCustomerCard(customerId: string): void;
  /**
   * @deprecated
   */
  displayCustomerCardCenter(customerId: string): void;
  /**
   * @deprecated
   */
  searchContactById(contactId: string, currentPage: number, itemsPerPage: number): IPromise<{ total: number; data: IRecipient[] }>;
  /**
   * @deprecated
   */
  getCustomerCards(contact: Booking): IPromise<CustomerData[]>;
  /**
   * @deprecated
   */
  getCustomerCard(id: string): IPromise<CustomerData | undefined>;
  /**
   * @deprecated
   */
  getCustomerCardById(contactId: string): IPromise<CustomerData | undefined>;
  /**
   * @deprecated
   */
  getCsrName(csrId: string): IPromise<User | undefined>;
}

export class CustomerCardsDeprecatedService implements ICustomerCardsDeprecatedService {
  static $inject: Array<string> = ['$q', 'httpDeprecated', 'elasticSearchService', 'customerService', 'customerFacade'];

  constructor(
    private readonly $q: IQService,
    private readonly httpDeprecated: HttpDeprecatedService,
    private readonly elasticSearchService: ElasticSearchService,
    private readonly customerService: CustomerService,
    private readonly customerFacade: CustomerFacade
  ) {}

  /**
   * @deprecated
   */
  linkCustomerCardToResponse(responseId: string, customerId: string, uri: string = ''): IPromise<any> {
    return this.httpDeprecated.asPromise().post(`${CSR_FACADE_PREFIX}/linkServiceResponseToContact`, [responseId, customerId, uri]);
  }

  /**
   * @deprecated
   */
  linkContactEntryToContact(interactionId: string, customerId: string): IPromise<any> {
    return this.httpDeprecated.asPromise().post(`${CSR_FACADE_PREFIX}/linkContactEntryToContact`, [interactionId, customerId]);
  }

  /**
   * @deprecated
   */
  displayPresomption(uri?: string): void {
    this.customerFacade.selectDialog(uri);
  }

  /**
   * @deprecated
   */
  displayNewCustomerCard(): void {
    this.customerFacade.createDialog();
  }

  /**
   * @deprecated
   */
  displayCustomerCard(customerId: string): void {
    this.customerFacade.updateDialog(customerId);
  }

  /**
   * @deprecated
   */
  displayCustomerCardCenter(customerId: string): void {
    this.customerFacade.manageDialog(customerId);
  }

  /**
   * @deprecated
   */
  searchContactById(contactId: string, currentPage: number, itemsPerPage: number): IPromise<{ total: number; data: IRecipient[] }> {
    return RxUtil.toPromise(
      this.customerService
        .searchByPartialContactlId({
          contactId,
          from: (currentPage - 1) * itemsPerPage,
          size: itemsPerPage,
        })
        .pipe(
          map(({ total, data }) => ({
            total,
            data: this.buildRecipientList(data),
          }))
        ),
      this.$q
    );
  }

  private buildRecipientList(docs: ContactDoc[]): IRecipient[] {
    return docs
      .reduce(
        (arr, cur) => [
          ...arr,
          ...cur.addresses
            .filter(address => address.channel === 'PHONE_INCOMING')
            .map(address => ({
              contactId: cur.contactId,
              id: address.externalId,
              name: (cur.contactFirstName || '') + ' ' + (cur.contactLastName || '').toUpperCase(),
              uuid: cur.uuid || '',
              lastname: cur.contactLastName || '',
              firstname: cur.contactFirstName || '',
              phone: address.uri,
            })),
        ],
        []
      )
      .sort((a, b) => (a.contactId > b.contactId ? 1 : b.contactId > a.contactId ? -1 : 0));
  }

  /**
   * @deprecated
   */
  getCustomerCards(contact: Booking): IPromise<CustomerData[]> {
    if (!!contact.customerId) {
      return RxUtil.toPromise(
        this.customerService.searchById({ id: contact.customerId }).pipe(
          map(doc => {
            if (!doc) {
              return [];
            }
            return [
              {
                customer: CustomerService.toEntity(doc),
                addresses: doc.addresses.map(address => CustomerService.toCustomerAddress(doc, address)),
              },
            ];
          })
        ),
        this.$q
      );
    } else if (!!contact.phoneNumber) {
      return RxUtil.toPromise(
        this.customerService.searchByPartialAddressUri({ uri: contact.phoneNumber }).pipe(
          map(({ data }) =>
            data.map(doc => ({
              customer: CustomerService.toEntity(doc),
              addresses: doc.addresses.map(address => CustomerService.toCustomerAddress(doc, address)),
            }))
          )
        ),
        this.$q
      );
    }
    return this.$q.resolve([]);
  }

  /**
   * @deprecated
   */
  getCustomerCard(id: string): IPromise<CustomerData | undefined> {
    return RxUtil.toPromise(
      this.customerService.searchById({ id }).pipe(
        map(
          doc =>
            doc && {
              customer: CustomerService.toEntity(doc),
              addresses: doc.addresses.map(address => CustomerService.toCustomerAddress(doc, address)),
            }
        )
      ),
      this.$q
    );
  }

  /**
   * @deprecated
   */
  getCustomerCardById(contactId: string): IPromise<CustomerData | undefined> {
    return RxUtil.toPromise(
      this.customerService.searchByContactId({ contactId }).pipe(
        map(
          doc =>
            doc && {
              customer: CustomerService.toEntity(doc),
              addresses: doc.addresses.map(address => CustomerService.toCustomerAddress(doc, address)),
            }
        )
      ),
      this.$q
    );
  }

  /**
   * @deprecated
   */
  getCsrName(userId: string): IPromise<User | undefined> {
    return RxUtil.toPromise(
      this.elasticSearchService
        .search(
          UserElsQuery.buildSearchById({
            id: userId,
            sort: { 'lastName.keyword': 'asc' },
          })
        )
        .pipe(
          map(({ data: [user] }) =>
            user
              ? {
                  id: user.uuid,
                  firstname: user.firstName,
                  lastname: user.lastName,
                  name: `${user.firstName} ${user.lastName}`,
                }
              : undefined
          )
        ),
      this.$q
    );
  }
}

export default 'customerCardsDeprecatedService';
